/**
 * 상세의 한 면이 펴는 실물 수 — **면마다 같은 값이다.**
 *
 * 🚨 **면마다 따로 적지 마라** — 같은 상세 안에서 면을 옮길 때마다 개수가 바뀌면
 *   「왜 여기만 적지?」가 된다. 값은 여기 하나다.
 * 🔑 넓은 화면 격자가 3열(광고·상품)과 4열(크리에이터·캠페인)이라 **30이 3열에 딱 열 줄**이고,
 *   4열에서는 마지막 줄에 둘이 남는다 — 칸 수가 폭마다 갈리므로 어느 수를 골라도 어딘가는 남는다.
 * ⚠️ **이 수를 넘는 것이 있으면 화면이 그렇게 적는다**(「N개 중 30개」) — 표본을 전부인 척하지 않는다.
 * ⚠️ 소셜포스팅은 상한이 아니라 **한 쪽 크기**다(「더 보기」로 끝까지 간다).
 */
export const BRAND_HUB_FACE_CARDS = 30;

/**
 * 면이 받는 크리에이터 수 — 표의 거름(채널·성별·연령대·규모)이 거를 거리가 있게 넉넉히 받는다.
 * ⚠️ 서버 상한이 100 이다. 줄마다 발굴 색인 프로필을 붙여 받는다(`withProfiles` · 묶음 조회 한 번).
 */
export const BRAND_HUB_CREATOR_LIST = 100;

/**
 * 화면이 실시간 조회 창구로 얼굴·팔로워를 더 채우는 사람 수 — 유료 창구라 위쪽만 묻는다.
 * 나머지는 서버가 붙인 색인 프로필로 선다.
 */
export const BRAND_HUB_CREATOR_LOOKUP = 30;
